import type { Predicate } from '@shared/core/search';
import { BE_DESCRIPTOR, type BusinessEntityDoc } from '@shared/core/search/entities/businessEntity';

import { EntityMultiPicker } from '../components/EntityMultiPicker';

export interface BusinessEntityMember {
  readonly name: string;
  readonly businessEntityId: number;
}

export interface BusinessEntityMultiPickerProps {
  readonly filter: Predicate<BusinessEntityDoc>;
  readonly value: readonly BusinessEntityMember[];
  readonly onChange: (entities: BusinessEntityMember[]) => void;
  readonly label?: string;
  readonly disabled?: boolean;
}

const toMember = (doc: BusinessEntityDoc): BusinessEntityMember => ({
  name: doc.name,
  businessEntityId: doc.businessEntityId,
});
const getLabel = (member: BusinessEntityMember): string => member.name;
const getKey = (member: BusinessEntityMember): number => member.businessEntityId;

export function BusinessEntityMultiPicker(props: BusinessEntityMultiPickerProps) {
  return (
    <EntityMultiPicker<BusinessEntityDoc, BusinessEntityMember>
      {...props}
      descriptor={BE_DESCRIPTOR}
      toOption={toMember}
      getOptionLabel={getLabel}
      getOptionKey={getKey}
    />
  );
}
